// eslint-disable-next-line @typescript-eslint/no-var-requires
var commaNumber = require("comma-number");
const priceCommaFormat = commaNumber.bindWith(",", ".");

const priceFormat = (num) => {
    if(num === "-"){
        return num;
    }

    if (num) {
        const twoDecimal = Math.round((num + Number.EPSILON) * 100) / 100;
        return priceCommaFormat(twoDecimal);
    }
    return num;
};

export default priceFormat;
